<div class="hold-transition sidebar-mini layout-navbar-fixed layout-footer-fixed">
    <!-- Site wrapper -->
    <div class="wrapper">
        <!-- Navbar -->
        <app-header></app-header>
        <!-- /.navbar -->

        <!-- Main Sidebar Container -->
        <app-sidebar [page]="'settings'" [subPage]="'countries'"></app-sidebar>

        <!-- Content Wrapper. Contains page content -->
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0">Settings</h1>
                    </div><!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a href="#">Home</a></li>
                            <li class="breadcrumb-item"><a href="#">Settings</a></li>
                            <li class="breadcrumb-item active">Countries</li>
                        </ol>
                    </div><!-- /.col -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->

            <!-- Main content -->
            <section class="content">
                <div class="container-fluid">
                    <app-module-menu [module]="'settings'" [activeSlug]="'countries'"></app-module-menu>
                    <div class="row">
                        <div class="modal fade" id="modal-country-form" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canWrite('country') || checkService.canModify('country')">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                <div class="card card-primary card-outline mb-0">
                                    <div class="card-header">
                                        <h4 class="card-title">{{formHeader}}</h4>
                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="onCancel()"><i class="fas fa-times"></i></button>
                                        </div>
                                    </div>
                                    <!-- form start -->
                                    <form [formGroup]="dataForm">
                                        <div class="card-body">
                                            <div class="form-group">
                                                <label for="title">Country Name</label>
                                                <input type="text" required [ngClass]="(title.invalid && (title.dirty || title.touched)) ? 'form-control is-invalid' : (title.valid)? 'form-control is-valid':'form-control'" formControlName="title" id="title" placeholder="Country Name">
                                                <div *ngIf="title.invalid && (title.dirty || title.touched)" class="invalid-feedback">
                                                    <div *ngIf="title.errors.required">Country name is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for="iso">ISO</label>
                                                <input type="text" required [ngClass]="(iso.invalid && (iso.dirty || iso.touched)) ? 'form-control is-invalid' : (iso.valid)? 'form-control is-valid':'form-control'" formControlName="iso" id="iso" placeholder="ISO">
                                                <div *ngIf="iso.invalid && (iso.dirty || iso.touched)" class="invalid-feedback">
                                                    <div *ngIf="iso.errors.required">ISO is required</div>
                                                </div>
                                            </div>
                                            <div class="alert alert-info mb-0">
                                                Create the country first, then use the currency button on the country row to attach one or more active currencies.
                                            </div>
                                        </div>
                                        <!-- /.card-body -->

                                        <div class="card-footer">
                                            <input type="hidden" formControlName="ref" id="ref">
                                            <button type="submit" [disabled]="!dataForm.valid || dataForm.pending || processing" (click)="onCreate()" class="btn btn-primary">{{buttonText}}</button>&nbsp;
                                            <button type="button" data-dismiss="modal" (click)="onCancel()" class="btn btn-default">Cancel</button>
                                        </div>
                                    </form>
                                <!-- /.card-body -->
                                </div>
                            </div>
                        </div>
                        </div>
                        <div class="modal fade" id="modal-country-currencies" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canModify('country')">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="card card-primary card-outline mb-0">
                                        <div class="card-header">
                                            <h4 class="card-title">Manage currencies - {{ selectedCountryForCurrencies?.title }}</h4>
                                            <div class="card-tools">
                                                <button type="button" class="btn btn-tool" data-dismiss="modal"><i class="fas fa-times"></i></button>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div class="alert alert-info">
                                                Select from active currencies already created in Settings.
                                                <a [routerLink]="['/settings/currencies']" data-dismiss="modal">Manage currencies</a>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6" *ngFor="let currency of currencyList">
                                                    <div class="custom-control custom-checkbox mb-2">
                                                        <input type="checkbox" class="custom-control-input" [id]="'currency-' + currency.ref" [checked]="isCurrencySelected(currency)" (change)="toggleCurrency(currency, $event)">
                                                        <label class="custom-control-label" [for]="'currency-' + currency.ref">{{ currency.code }} - {{ currency.name }} <span class="text-muted">{{ currency.symbol }}</span></label>
                                                    </div>
                                                </div>
                                                <div class="col-12 text-center text-muted" *ngIf="currencyList.length == 0">No active currencies created yet.</div>
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <button type="button" class="btn btn-primary" [disabled]="processing || selectedCurrencyRefs.length == 0" (click)="saveCountryCurrencies()">Save Currencies</button>
                                            <button type="button" class="btn btn-default ml-2" data-dismiss="modal">Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- /.col -->
                        <div class="col-md-12">
                            <div class="card card-primary card-outline">
                                <img [hidden]='!loading' [class]="loading?'mx-auto d-block':''" src="assets/LoadingGIF/Rolling-1s-75px.gif">

                                <!-- Default box -->
                                <div class="card card-solid" [hidden]='loading'>
                                    <div class="card-header">
                                        <h3 class="card-title">
                                            <i class="fas fa-edit"></i>
                                            {{mainHeader}}
                                        </h3>
                                        <div class="text-right"> 
                                            <div class="btn-group">
                                                <button type="button" class="btn btn-primary btn-sm" *ngIf="checkService.canWrite('country')" data-toggle="modal" data-target="#modal-country-form" (click)="onCancel()">
                                                    <i class="fas fa-plus"></i> Add Country
                                                </button>&nbsp;
                                                <a [routerLink]="['/settings/countries']" class="btn btn-primary btn-sm" type="button">All</a>&nbsp;
                                                <a [routerLink]="['/settings/countries/active']" class="btn btn-primary btn-sm" type="button">Active</a>&nbsp;
                                                <a [routerLink]="['/settings/countries/inactive']" class="btn btn-primary btn-sm" type="button">In-Active</a>&nbsp;
                                                
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" placeholder="Search Mail">
                                                </div>
                                                <button [routerLink]="['/adverts/Deleted']" class="btn btn-primary btn-sm" type="button"><i class="fas fa-search"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>Country Name</th>
                                                    <th>ISO Code</th>
                                                    <th>Currency</th>
                                                    <th>Status</th>
                                                    <th>Created</th>
                                                    <th>Last Modified</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let countryRow of countryList;">
                                                    <td>{{countryRow.title}}</td>
                                                    <td>{{countryRow.iso}}</td>
                                                    <td>
                                                        <span *ngFor="let currency of (countryRow.currencies?.length ? countryRow.currencies : [countryRow.currency])" class="badge badge-info mr-1">
                                                            {{ currency.code }} - {{ currency.name }}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span [class]="countryRow.online === true ? 'badge bg-success' : 'badge bg-danger'" [innerHTML]="countryRow.online === true ? 'Online' : 'Offline'"></span><br>
                                                        <span [class]="countryRow.status.active === true ? 'badge bg-success' : countryRow.status.inactive === true ? 'badge bg-warning' : 'badge bg-danger'" [innerHTML]="countryRow.status.active === true ? 'Active' : countryRow.status.inactive === true ? 'In-Active' : 'Deleted'"></span>
                                                    </td>
                                                    <td>{{countryRow.created}}</td>
                                                    <td>{{countryRow.lastModified}}</td>
                                                    <td>
                                                        <div class="btn-group btn-group-sm">
                                                            <button type="button" class="btn btn-info" title="Modify" *ngIf="checkService.canModify('country')" data-toggle="modal" data-target="#modal-country-form" (click)="getEdit(countryRow)">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                            <a class="btn btn-secondary" title="View Areas" *ngIf="checkService.canRead('country.areas')" [routerLink]="['/settings/countries/areas', countryRow.ref]">
                                                                <i class="fas fa-list"></i>
                                                            </a>
                                                            <button type="button" class="btn btn-primary" title="Assign currencies to this country" *ngIf="checkService.canModify('country')" data-toggle="modal" data-target="#modal-country-currencies" (click)="openCurrencyManager(countryRow)">
                                                                <i class="fas fa-coins mr-1"></i> Currencies ({{ countryRow.currencies?.length || 0 }})
                                                            </button>
                                                            <button type="button" class="btn btn-success" title="Show" *ngIf="checkService.canModify('country')" [hidden]="countryRow.online === true" data-toggle="modal" data-target="#modal-online" (click)="getDataFromList(countryRow.title, countryRow.ref)">
                                                                <i class="fas fa-eye"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-secondary" title="Hide" *ngIf="checkService.canModify('country')" [hidden]="countryRow.online === false" data-toggle="modal" data-target="#modal-offline" (click)="getDataFromList(countryRow.title, countryRow.ref)">
                                                                <i class="fas fa-eye-slash"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-success" title="Activate" *ngIf="checkService.canModify('country')" [hidden]="countryRow.status.active === true" data-toggle="modal" data-target="#modal-activate" (click)="getDataFromList(countryRow.title, countryRow.ref)">
                                                                <i class="fas fa-check"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-warning" title="Deactivate" *ngIf="checkService.canModify('country')" [hidden]="countryRow.status.inactive === true" data-toggle="modal" data-target="#modal-deactivate" (click)="getDataFromList(countryRow.title, countryRow.ref)">
                                                                <i class="fas fa-ban"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" title="Delete" *ngIf="checkService.canModify('country')" data-toggle="modal" data-target="#modal-delete" (click)="getDataFromList(countryRow.title, countryRow.ref)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr *ngIf="countryList.length == 0">
                                                    <td colspan="6" class="text-center">No record to show</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>Country Name</th>
                                                    <th>ISO Code</th>
                                                    <th>Currency</th>
                                                    <th>Status</th>
                                                    <th>Created</th>
                                                    <th>Last Modified</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <!-- /.card-body -->
                                    <div class="card-footer" *ngIf="countryList.length > 0">
                                        <app-pagination [url]='url' [counts]='count'(refresh)="getCountries($event)"></app-pagination>
                                    </div>
                                    <!-- /.card-footer -->
                                </div>
                            </div>
                        <!-- /.card -->
                        </div>
                        <!-- /.col -->
                    </div>
                <!-- /.row -->
                </div><!-- /.container-fluid -->
            </section>
            <!-- /.content -->
            <!-- /.content-wrapper -->

        </div>
        <!-- /.content-wrapper -->
        <app-footer></app-footer>
    </div>
    <!-- ./wrapper -->
</div>
<div class="modal fade" id="modal-activate">
    <div class="modal-dialog">
      <div class="modal-content bg-secondary">
        <div class="modal-header">
          <h4 class="modal-title">Activate Country</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p [innerHTML]="'This action will activate '+countryName+'. Are you sure you want to continue ?'"></p>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
          <button type="button" (click)="changeCountryStatus('activate', countryRef)" class="btn btn-outline-light">Activate Country</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
<div class="modal fade" id="modal-deactivate">
      <div class="modal-dialog">
        <div class="modal-content bg-secondary">
          <div class="modal-header">
            <h4 class="modal-title">Deactivate Country</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p [innerHTML]="'This action will deactivate '+countryName+'. Are you sure you want to continue ?'"></p>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
            <button type="button" (click)="changeCountryStatus('deactivate', countryRef)" class="btn btn-outline-light">Deactivate Country</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
<div class="modal fade" id="modal-online">
    <div class="modal-dialog">
      <div class="modal-content bg-secondary">
        <div class="modal-header">
          <h4 class="modal-title">Show Country in App</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p [innerHTML]="'This action will show '+countryName+' in App. Are you sure you want to continue ?'"></p>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
          <button type="button" (click)="changeCountryVisibility('show', countryRef)" class="btn btn-outline-light">Show Country in App</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
<div class="modal fade" id="modal-offline">
      <div class="modal-dialog">
        <div class="modal-content bg-secondary">
          <div class="modal-header">
            <h4 class="modal-title">Hide Country in App</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p [innerHTML]="'This action will Hide '+countryName+' in App. Are you sure you want to continue ?'"></p>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
            <button type="button" (click)="changeCountryVisibility('hide', countryRef)" class="btn btn-outline-light">Hide Country in App</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
<div class="modal fade" id="modal-delete">
    <div class="modal-dialog">
      <div class="modal-content bg-secondary">
        <div class="modal-header">
          <h4 class="modal-title">Delete Country</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p [innerHTML]="'This action will remove '+countryName+'. This action is not reversable, are you sure you want to continue ?'"></p>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-outline-light" (click)="deleteCountry(countryRef)">Delete Country</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
